import $ from 'jquery';
var Marionette = require('backbone.marionette');
var _ = require('underscore');


var PaginationView = Marionette.LayoutView.extend({
  className: 'pagination',

  template: require('../templates/pages/list.html'),

  templateHelpers() {
    var collection = this.collection;
    var range = this.collection.state.pagesInRange;

    var before = _.map(_.range(range, 0, -1), function (page) {
      return collection.state.currentPage - page;
    });
    before = _.filter(before, function (page) {
      return page > 0;
    });

    var after = _.map(_.range(1, range + 1), function (page) {
      return collection.state.currentPage + page;
    });
    after = _.filter(after, function (page) {
      return page <= collection.state.totalPages;
    });

    return {
      currentPage: collection.state.currentPage,
      pagesBefore: before,
      pagesAfter: after
    };
  },

  collectionEvents: {
    reset: 'render',
    add: 'render',
    fetch: 'render'
  },

  ui: {
    first: '.first',
    previous: '.previous',
    next: '.next',
    last: '.last',
    page: '.page',
    pageRange: '.page_range'
  },

  triggers: {
    'click @ui.first': 'click:first',
    'click @ui.previous': 'click:previous',
    'click @ui.next': 'click:next',
    'click @ui.last': 'click:last',
    'change @ui.pageRange': 'change:pageRange'
  },

  events: {
    'click @ui.page': 'onClickPage'
  },

  onRender() {
    this.ui.pageRange.val(this.collection.state.pageSize);
  },

  onChangePageRange() {
    this.collection.state.pageSize = parseInt(this.ui.pageRange.val());
    this.collection.getFirstPage(this._options());
  },

  onClickFirst() {
    this.collection.getFirstPage(this._options());
  },

  onClickLast() {
    this.collection.getLastPage(this._options());
  },

  onClickNext() {
    if (this.collection.hasNextPage()) {
      this.collection.getNextPage(this._options());
    }
  },

  onClickPrevious() {
    if (this.collection.hasPreviousPage()) {
      this.collection.getPreviousPage(this._options());
    }
  },

  onClickPage(event) {
    event.stopPropagation();
    var page = parseInt($(event.target).data('page'));
    this.collection.getPage(page, this._options());
  },

  _options() {
    return {
      fetch: true,
      reset: true
    };
  }
});


module.exports = PaginationView;



// WEBPACK FOOTER //
// ./base/views/page.js